export const TRIAL_PAGES_V2C = 'v2c';
